<template>
    <div>
        <v-card elevation="0">
            <v-card color="#7CB342" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-list-status</v-icon>
                    &nbsp;My Applications
                </v-card-title>
            </v-card>
            <MyApplications />
        </v-card>
    </div>
</template>
<script>
import MyApplications from "../../../components/Applicants/MyApplication/MyApplication.vue"
export default {
    components: {
        MyApplications
    }
}
</script>